import React from 'react';

import './product-procedure.styles.scss';

/* eslint-disable-next-line */
export interface ProductProcedureProps {}

export function ProductProcedure(props: ProductProcedureProps) {
  return (
    <div className="product-procedure ptb-100">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12">
            <div className="procedure-content">
              <span className="sub-title">Process</span>
              <h2>How it Works</h2>

              <div className="inner-box">
                <div className="single-item">
                  <div className="count-box">1</div>
                  <h3>Collect Commuting Information</h3>
                  <p>
                    Collecting this information helps us understand your
                    commutes to plan better routes & offer better pricing.
                  </p>
                </div>
                <div className="single-item">
                  <div className="count-box">2</div>
                  <h3>Schedule Rides</h3>
                  <p>
                    Hop In will plan & schedule your rides. All you have to do
                    is arrive at the designated pick up location.
                  </p>
                </div>
                <div className="single-item">
                  <div className="count-box">3</div>
                  <h3>Start Riding!</h3>
                  <p>Ride. Relax. Repeat.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="how-its-work-image">
              <img
                src={require('../../../assets/photos/product-statement/product-procedure.png')}
                alt="banner"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductProcedure;
